<template>

  <div class="clm-ctrl-lang" @click="$i18n.locale = `ru`">
    <button class="clm-ctrl-lang__btn clm-btn">
            <span class="clm-btn__text">
              RU
            </span>
    </button>
  </div>

  <div class="clm-ctrl-lang" @click="$i18n.locale = `kz`">
    <button class="clm-ctrl-lang__btn clm-btn">
            <span class="clm-btn__text">
              KZ
            </span>
    </button>
  </div>

  <!--
  <div class="clm-ctrl-lang">
    <button class="clm-ctrl-lang__btn clm-btn" v-if="locale && locale.enabled">
      <span class="clm-btn__text">
        {{ locale.actual }}
      </span>
    </button>
  </div>
  -->
</template>

<script>
export default {
  name: "clm-ctrl-lang",
  props: {
    locale: {
      type: Object,
    },
  }
}
</script>
